import { useCallback, useState } from "react";
import moment from "moment";
import { fetchGoogleEmailByAddress } from "../../redux/constants/integrationApi";

const extractEmail = (str) => {
  const match = str?.match(/<(.+?)>/);
  return match ? match[1].trim() : str?.trim() || "";
};

export const useGmail = () => {
  const [loading, setLoading] = useState(false);

  const fetchEmails = useCallback(async ({ filterEmail, pageToken = "", pagerequire = 10, pagenumber = 1 }) => {
    try {
      setLoading(true);

      const response = await fetchGoogleEmailByAddress(
        filterEmail,
        pageToken,
        pagerequire,
        pagenumber,
      );

      if (response?.status === false) {
        return {
          records: [],
          nextPageToken: "",
          signinRequire: false,
          error: response?.message || "Unable to fetch emails.",
        };
      }

      const emails =
        response?.data?.emails ||
        response?.emails ||
        response?.data ||
        response ||
        [];
      const loggedInEmail = String(
        window.localStorage.getItem("googleEmail") || "",
      ).toLowerCase();

      const normalizedEmails = Array.isArray(emails) ? emails : [];

      return {
        records: normalizedEmails.map((email) => {
          const emailDate = email.date || email.receivedDateTime || "";
          const parsedDate = emailDate ? moment(emailDate) : null;
          const labels = email.labelIds || email.labels || [];
          const from = email.from || "";
          const to = email.to || "";
          const cc = email.cc || "";

          return {
            id: email.id || email.messageId || email.threadId,
            threadId: email.threadId || "",
            from,
            to,
            cc,
            subject: email.subject || "No Subject",
            body:
              email.bodyHtml ||
              email.bodyPlain ||
              email.body ||
              email.snippet ||
              "No email body available.",
            snippet: email.snippet || "",
            labels,
            attachments: email.attachments || [],
            date:
              parsedDate && parsedDate.isValid()
                ? parsedDate.format("DD/MM/YYYY")
                : "",
            time:
              parsedDate && parsedDate.isValid()
                ? parsedDate.format("HH:mm")
                : "",
            direction:
              email.direction ||
              (labels.includes("SENT") ||
              extractEmail(from).toLowerCase() === loggedInEmail
                ? "sent"
                : "received"),
          };
        }),
        nextPageToken:
          response?.data?.nextPageToken || response?.nextPageToken || "",
        totalEmails: response?.data?.resultSizeEstimate || 0,
        totalPages: Math.ceil(
          (response?.data?.resultSizeEstimate || 0) / pagerequire,
        ),
        currentPage: pagenumber,
        pageSize: pagerequire,
        signinRequire:
          response?.signinRequire ||
          response?.data?.signinRequire ||
          response?.status === 401,
      };
    } catch (error) {
      console.error("Error fetching emails:", error);

      return {
        records: [],
        nextPageToken: "",
        signinRequire: error?.response?.status === 401,
        error:
          error?.response?.data?.message ||
          error?.message ||
          "Unable to fetch emails.",
      };
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, fetchEmails };
};
